export function headerHandler() {
    const isTouch = this.isTouch;
    const $html = this.$html;
    const $window = this.$window;
    const $body = this.$body;
    const $header = this.$header;
    const $switcher = $(".site-nav-switcher");
    const $mainNav = this.$header.find(".main-nav");
    const $thirdLevelSubMenu = $mainNav.find(".main-menu > .menu-item-has-children > .sub-menu > .menu-item-has-children > .sub-menu");
    let mobileActiveLevel = 1;
    let desktopActiveLevel = 2;


    $("<button class=\"sub-menu-back-link\" aria-label=\"go to first level of the navigation\">Back</button>").insertBefore(".main-menu");
    $("<button class=\"sub-menu-expander\" aria-label=\"submenu expander\"></button>").insertAfter(".main-menu .menu-item-has-children > a");

    $mainNav.attr("data-active-level", mobileActiveLevel);

    $(".sub-menu-expander").on(this.pushEvent, function () {
        const $this = $(this);
        const $parent = $this.closest(".menu-item");
        const ww = $window.outerWidth();

        if (isTouch || ww < 1200) {
            $mainNav.attr("data-active-level", ++mobileActiveLevel);

            if ($html.hasClass("main-sub-menu-is-open") && $mainNav.attr("data-active-level") === 1) {
                $html.removeClass("main-sub-menu-is-open");
            } else {
                $html.addClass("main-sub-menu-is-open");
            }

            if ($parent.hasClass("active-sub-menu") && $mainNav.attr("data-active-level") === 1) {
                $parent.removeClass("active-sub-menu");
            } else {
                $parent.addClass("active-sub-menu");
            }
        } else {
            $mainNav.attr("data-active-level", ++desktopActiveLevel);
            $parent.addClass("desktop-active-sub-menu");
        }
    });

    $(".sub-menu-back-link").on(this.pushEvent, function () {
        $mainNav.attr("data-active-level", --mobileActiveLevel);
        const ww = $window.outerWidth();
        if (isTouch || ww < 1200) {
            if ($mainNav.attr("data-active-level") === "1") {
                if ($html.hasClass("main-sub-menu-is-open")) {
                    $html.removeClass("main-sub-menu-is-open");
                }
                $(".active-sub-menu").removeClass("active-sub-menu");
            }
            if ($mainNav.attr("data-active-level") === "2") {
                $(".main-menu > .active-sub-menu .active-sub-menu").removeClass("active-sub-menu");
            }
        }
    });

    if ($thirdLevelSubMenu.length) {
        $("<button class=\"desktop-sub-menu-back-link\" aria-label=\"go to second level of the navigation\">Back</button>").insertBefore(".main-menu > .menu-item-has-children > .sub-menu > .menu-item-has-children > .sub-menu > .menu-item:first-child");
    }

    $(".desktop-sub-menu-back-link").on(this.pushEvent, function () {
        $mainNav.attr("data-active-level", --desktopActiveLevel);
        $(".desktop-active-sub-menu").removeClass("desktop-active-sub-menu");
    });

    $header.on("mouseleave", "[data-active-level='3'] .sub-menu", function () {
        desktopActiveLevel = 2;
        const ww = $window.outerWidth();
        if(!isTouch && ww > 1200) {       
            $mainNav.attr("data-active-level", desktopActiveLevel);
            $(".desktop-active-sub-menu").removeClass("desktop-active-sub-menu");
        }
    });

    $switcher.on(this.pushEvent, () => {
        if (this.$html.hasClass("site-navigation-is-open")) {
            this.$html.removeClass("site-navigation-is-open");
            this.$header.css("height", "auto");
        } else {
            this.$html.addClass("site-navigation-is-open");
            this.$header.css("height", this.$window.outerHeight());
        }
    });

    this.win.addEventListener("resize", () => {
        setTimeout(() => {
            const ww = $window.outerWidth();            
            if (!isTouch && ww >= 1200) {
                this.$html.removeClass("site-navigation-is-open");
                desktopActiveLevel = 2;
                $mainNav.attr("data-active-level", desktopActiveLevel);
                // this.$header.css("height", "auto");
                this.$html.removeClass("main-sub-menu-is-open");
            } else {
                // this.$header.css("height", this.$window.outerHeight());
                if (!$html.hasClass("main-sub-menu-is-open")) {
                    mobileActiveLevel = 1;
                    $mainNav.attr("data-active-level", mobileActiveLevel);
                }
                if ($(".desktop-active-sub-menu").length) {
                    $(".desktop-active-sub-menu").removeClass("desktop-active-sub-menu");
                }
            }
        }, 500);
        
        if ($body.hasClass("is-desktop")){
            const ww = $window.outerWidth();
            if(ww < 1200) {
                document.body.classList.remove("no-touch");
                document.body.classList.add("touch");
            }else{
                document.body.classList.remove("touch");
                document.body.classList.add("no-touch");
            }
        } 

    });

    this.win.addEventListener("orientationchange", () => {
        setTimeout(() => {
            if (!isTouch) {
                this.$html.removeClass("main-sub-menu-is-open");
                this.$html.removeClass("site-navigation-is-open");
                this.$header.css("height", "auto");

                desktopActiveLevel = 2;
                $mainNav.attr("data-active-level", desktopActiveLevel);
            } else {
                // mobileActiveLevel = 1;
                // $mainNav.attr("data-active-level", mobileActiveLevel);
                // this.$header.css("height", this.$window.outerHeight());
            }
        }, 100);
    });


}

export function headerScrollHandler() {
    const $html = this.$html;
    const $window = this.$window;
    const globalWindow = this.win;
    let lastScrollTop = $window.scrollTop() > 0 ? $window.scrollTop() : 0;
    let deadline = detectDeadline();

    function detectDeadline() {
        // const $heroSection = $(".hero-section");
        // let minHeightOfFirstScreen = 548;
        // let heroSectionIsExist = $heroSection.length;
        // let deadline = heroSectionIsExist ? $heroSection.outerHeight() : minHeightOfFirstScreen;
        // return deadline > 600 ? 600 : deadline;
        return $(".hero-section").outerHeight();
    }

    function init() {
        lastScrollTop = $window.scrollTop() > 0 ? $window.scrollTop() : 0;
        deadline = detectDeadline();

        if (lastScrollTop > deadline) {
            $html.addClass("header-sticky");
        } else {
            $html.removeClass("header-sticky");
        }
    }

    function scroll() {
        // let st = $(this).scrollTop();
        let st = globalWindow.pageYOffset;
        let innerPageHeight = $(".hero-section").outerHeight();


        if (st > innerPageHeight / 2) {
            if (!$html.hasClass("header-sticky")) {
                $html.addClass("header-sticky").addClass("no-tr");
                setTimeout(() => {
                    $html.removeClass("no-tr");
                }, 100);
            }
        } else {
            $html.removeClass("header-sticky");
        }
        if (st > innerPageHeight) {
            if (!$html.hasClass("change-bg")) {
                $html.addClass("change-bg");
            }
        } else {
            $html.removeClass("change-bg");
        }


        // if (st > lastScrollTop) {
        //     // console.log("down");
        //
        //     if (st > deadline) {
        //         $html.addClass("header-sticky");
        //     }
        //
        // } else if (st == lastScrollTop) {
        //     //do nothing
        //     //In IE this is an important condition because there seems to be some instances where the last scrollTop is equal to the new one
        // } else {
        //     // console.log("up");
        //
        //     if (st === 0) {
        //         $html.removeClass("header-sticky");
        //     }
        // }

        lastScrollTop = st;
    }

    $window.on("load resize", () => {
        init();
    });
    $window.on("scroll", function () {
        scroll();
    });
   
}


// WEBPACK FOOTER //
// ./assets/js/modules/header.js